import { Color } from '@tmh-website/shared/colors';
import { Project } from '@tmh-website/shared/const';

import type { FooterProps } from './Footer';

const DEFAULT_BACKGROUND_COLOR: FooterProps['backgroundColor'] = Color.Blue_1000_Deep;

export const PROJECT_TO_BACKGROUND_COLOR_MAP: Record<Project, FooterProps['backgroundColor']> = {
  [Project.ElectricityTariff]: DEFAULT_BACKGROUND_COLOR,
  [Project.EMobilityAssistant]: DEFAULT_BACKGROUND_COLOR,
  [Project.Energy]: Color.Green_1000_Energy,
  [Project.Styleguide]: DEFAULT_BACKGROUND_COLOR,
  [Project.Website]: DEFAULT_BACKGROUND_COLOR,
};
